import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-dates-filters',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './dates-filters.component.html',
  styleUrl: './dates-filters.component.scss'
})
export class DatesFiltersComponent {
  @Input() form!: FormGroup;
  @Input() submitted = false;
  @Input() showAsignationDate = false;
  @Input() showCreationDate = false;
  @Input() showDueDate = false;
  @Input() showStartTrip = false;
  @Input() showEndTrip = false;
  @Input() showUploadDate = false;
  @Input() showUploadTripDateRange = false;
  @Input() showDateCreationRange = false;
  @Input() showDateApprovalRange = false;
  @Input() showExpirationDateRange = false;
  @Input() showUploadDateRange = false;
  @Input() showDueDateRange = false;
  @Input() showStartTripOne = false;
  @Input() showEndTripOne = false;
  @Input() showDeliveryDate = false;

  @Input() loadData: boolean = undefined;

  ngOnInit() {
    if (this.showUploadDate) this.form.get("uploadDate").setValue(new Date());
  }

}
